<template>
  <div class="py-2 px-4 text-base-content/50 overflow-auto">
    <!-- 背景音乐 -->
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.base.backgroundMusic") }}
          <span class="text-[#E84B4B]">*</span>
        </h2>
      </div>
      <VanField
        v-model="bgm"
        :placeholder="$t('game.clickChooseBackgroundMusic')"
        class="bg-base-100 border rounded"
        is-link
        name="picker"
        readonly
        required
        @click="clickSelectBgm"
      />
    </div>

    <!-- 参与 Mate -->
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.base.characterzz") }}
          <span class="text-[#E84B4B]">*</span>
        </h2>

        <div>
          <button
            class="btn btn-xs rounded mr-2"
            @click="store.showSelectMateModal = true"
          >
            {{ $t("Buttons.add") }}
          </button>
        </div>
      </div>

      <div class="border pt-5 px-2.5">
        <ShowCharacterEditor
          v-for="(character, idx) in store.form.characterzz"
          :character="character"
          :idx="idx"
        />
      </div>
    </div>
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.base.player") }}
          <span class="text-[#E84B4B]">*</span>
        </h2>
      </div>

      <div class="flex border py-5 px-2.5 gap-2">
        <ShowCharacterEditor :character="store.form.player" :idx="-1" />
      </div>
    </div>

    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.role.4") }}
        </h2>
      </div>

      <div class="flex border py-5 px-2.5 gap-2">
        <ShowCharacterEditor
          :character="store.form.narrator"
          :idx="-1"
          only-tone
        />
      </div>
    </div>

    <ToneSelectionPopup
      v-model:show="store.showSelectCharacterToneModal"
      :selected-tone-id="selectedToneId"
      @update:selected-tone-id="store.onUpdateCharacterTone"
    />
  </div>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useTone } from "@/stores/tone";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const toneStore = useTone();
const { bgmList } = storeToRefs(toneStore);

const bgm = computed(
  () => bgmList.value.find((v) => v.mediaId === store.form.bgmMediaId)?.name
);

const clickSelectBgm = () => {
  store.bgmType = 0;
  store.showBgmModal = true;
  store.currentBgmId =
    toneStore.getBgmByMediaId(store.form.bgmMediaId)?.id ?? 0;
};

// 音色选择
const selectedToneId = computed(() => {
  return store.activeCharacterId
    ? store.characterIdMap[store.activeCharacterId].mateToneId
    : 0;
});
</script>
